import React from 'react';
import './OrderFilters.css';

interface OrderFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  statusFilter: string;
  onStatusFilterChange: (status: string) => void;
  restaurantFilter: string;
  onRestaurantFilterChange: (restaurant: string) => void;
}

const OrderFilters: React.FC<OrderFiltersProps> = ({
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  restaurantFilter,
  onRestaurantFilterChange,
}) => {
  return (
    <div className="order-filters">
      <div className="order-search">
        <span className="search-icon">🔍</span>
        <input
          type="text"
          placeholder="Search by order ID, customer, restaurant..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="order-search-input"
        />
      </div>
      <div className="order-filter-controls">
        <select
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
          className="order-filter-select"
        >
          <option>All Status</option>
          <option>Completed</option>
          <option>Preparing</option>
          <option>Pending</option>
          <option>Ready</option>
          <option>Cancelled</option>
        </select>
        <select
          value={restaurantFilter}
          onChange={(e) => onRestaurantFilterChange(e.target.value)}
          className="order-filter-select"
        >
          <option>All Restaurants</option>
          <option>Pizza Palace</option>
          <option>Burger Spot</option>
          <option>Sushi House</option>
          <option>Taco Express</option>
          <option>Pasta Kitchen</option>
        </select>
        <button className="order-more-filters-btn">
          <span>🔽</span> More Filters
        </button>
      </div>
    </div>
  );
};

export default OrderFilters;

